import * as React from 'react';
import { useTheme } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface AddAccountProps {
  handleOpenDialog?: (event: React.MouseEvent<HTMLElement>) => void;
  handleCloseDrawer: () => void;
}

export default function NotificationSettings(props: AddAccountProps) {
  const { handleCloseDrawer } = props;
  const theme = useTheme();
  const { t } = useTranslation('account');

  return (
    <ListItem disablePadding>
      <ListItemButton
        component={Link}
        to="/register/spot"
        preventScrollReset={true}
        onClick={handleCloseDrawer}
      >
        <ListItemIcon>
          <theme.icons.addPerson fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={t('menu.add pro account')} />
      </ListItemButton>
    </ListItem>
  );
}
